import { render, staticRenderFns } from "./SingleCamera.vue?vue&type=template&id=20a08a52&scoped=true"
import script from "./SingleCamera.vue?vue&type=script&lang=js"
export * from "./SingleCamera.vue?vue&type=script&lang=js"
import style0 from "./SingleCamera.vue?vue&type=style&index=0&id=20a08a52&prod&lang=less&scoped=true"
import style1 from "./SingleCamera.vue?vue&type=style&index=1&id=20a08a52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a08a52",
  null
  
)

export default component.exports